(() => {
  if (customElements.get('ns-review-carousel')) return;
  class ReviewCarousel extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      try { this.products = JSON.parse(this.querySelector('[data-review-products]')?.textContent || '[]'); } catch (_) { this.products = []; }
      const on = (el, event, handler) => el.addEventListener(event, handler, { signal: this.abort.signal });
      this.track = this.querySelector('.ns-reviews__track');
      this.prev = this.querySelector('.ns-reviews__arrow--prev');
      this.next = this.querySelector('.ns-reviews__arrow--next');
      this.dialog = this.querySelector('dialog');
      this.photos = document.querySelector('[data-home-customer-photos] .ns-review-photos') || this.querySelector('.ns-review-photos');
      this.photoTrack = this.photos?.querySelector('.ns-review-photos__track');
      if (this.photos) {
        on(this.photos, 'click', e => {
          const photo = e.target.closest('[data-photo-review]');
          if (photo) this.openReview(this.reviews[Number(photo.dataset.photoReview)]);
          const arrow = e.target.closest('[data-photo-step]');
          if (arrow) this.photoTrack.scrollBy({left:Number(arrow.dataset.photoStep) * (this.photoTrack.firstElementChild?.getBoundingClientRect().width + 14 || 240),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant':'smooth'});
        });
        on(this.photoTrack, 'scroll', () => this.updatePhotoButtons());
      }
      on(this.prev, 'click', () => this.move(-1));
      on(this.next, 'click', () => this.move(1));
      on(this.track, 'scroll', () => this.updateButtons());
      on(this.track, 'keydown', e => {
        if (e.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(e.key)) return;
        e.preventDefault(); this.move(e.key === 'ArrowLeft' ? -1 : 1);
      });
      on(this.track, 'click', e => {
        const card = e.target.closest('[data-review-index]');
        if (card) this.openReview(this.reviews[Number(card.dataset.reviewIndex)]);
      });
      on(this.querySelector('.ns-reviews__close'), 'click', () => this.dialog.close());
      this.resize = new ResizeObserver(() => {this.updateButtons();this.updatePhotoButtons();});
      this.resize.observe(this.track);
      this.source = document.querySelector(`[id$="__${this.dataset.sourceSection}"] .jdgm-carousel-wrapper`);
      if (!this.source) return;
      this.observer = new MutationObserver(() => {
        clearTimeout(this.timer); this.timer = setTimeout(() => this.sync(), 150);
      });
      this.observer.observe(this.source, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-score', 'data-number-of-reviews'] });
      this.sync();
    }
    disconnectedCallback() {
      this.abort?.abort(); this.observer?.disconnect(); this.resize?.disconnect(); clearTimeout(this.timer);
    }
    node(tag, className, text) {
      const el = document.createElement(tag); if (className) el.className = className;
      if (text !== undefined) el.textContent = text; return el;
    }
    stars(target, rating) {
      target.replaceChildren(); target.setAttribute('role', 'img');
      target.setAttribute('aria-label', `${rating.toLocaleString('de-DE')} von 5 Sternen`);
      for (let i = 0; i < 5; i++) {
        const star = this.node('span', 'ns-reviews__star'); star.setAttribute('aria-hidden', 'true');
        const fill = this.node('span', 'ns-reviews__star-fill');
        fill.style.setProperty('--fill', `${Math.max(0, Math.min(1, rating - i)) * 100}%`);
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg'); svg.setAttribute('viewBox', '0 0 24 24');
        const path = document.createElementNS(svg.namespaceURI, 'path');
        path.setAttribute('d', 'M12 1.5 15.1 8h7.2l-5.8 4.7 2.2 7.3L12 15.5 5.3 20l2.2-7.3L1.7 8h7.2Z');
        svg.append(path); star.append(fill, svg); target.append(star);
      }
    }
    sync() {
      const score = Number(this.source.querySelector('[data-score]')?.dataset.score);
      const count = Number(this.source.querySelector('[data-number-of-reviews]')?.dataset.numberOfReviews);
      const seen = new Set(); const reviews = [];
      this.source.querySelectorAll('.jdgm-carousel-item[data-review-id]').forEach(item => {
        const id = item.dataset.reviewId; if (seen.has(id)) return; seen.add(id);
        const text = selector => item.querySelector(selector)?.textContent.trim() || '';
        const ratingNode = item.querySelector('.jdgm-carousel-item__review-rating');
        const rating = ratingNode ? ratingNode.querySelectorAll('.jdgm--on').length + ratingNode.querySelectorAll('.jdgm--half').length / 2 : 0;
        const bodyNode = item.querySelector('.jdgm-carousel-item__review-body');
        const bodyCopy = bodyNode?.cloneNode(true);
        bodyCopy?.querySelectorAll('br').forEach(br => br.replaceWith('\n'));
        bodyCopy?.querySelectorAll('p').forEach(p => p.append('\n'));
        const body = bodyCopy?.textContent.trim() || '';
        if (!rating || !body) return;
        const rawDate = item.querySelector('[data-time]')?.dataset.time || '';
        const parts = rawDate.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
        const date = parts ? `${parts[2].padStart(2, '0')}.${parts[1].padStart(2, '0')}.${parts[3]}` : '';
        const image = item.querySelector('.jdgm-carousel-item__product-image');
        const candidate = image?.getAttribute('data-src-retina') || image?.getAttribute('data-src') || image?.getAttribute('src') || '';
        let photo = '';
        try { const url = new URL(candidate, location.href); if(url.protocol === 'https:' && url.hostname === 'review-images.judgeme.com') photo = url.href; } catch (_) {}
        reviews.push({ id, rating, body, date, photo, product: image?.alt || '', title: text('.jdgm-carousel-item__review-title'), author: text('.jdgm-carousel-item__reviewer-name') });
      });
      if (!(score > 0 && score <= 5 && count > 0 && reviews.length)) { this.hidden = true; return; }
      const signature = JSON.stringify([score, count, reviews]); if (signature === this.signature) return;
      this.signature = signature; this.reviews = reviews;
      this.querySelector('[data-rating-label]').textContent = 'Bewertungen';
      this.stars(this.querySelector('[data-total-stars]'), score);
      this.querySelector('[data-total-score]').textContent = `${score.toLocaleString('de-DE', { maximumFractionDigits: 2 })} von 5`;
      this.querySelector('[data-total-count]').textContent = `Basierend auf ${count.toLocaleString('de-DE')} Bewertungen`;
      const fragment = document.createDocumentFragment();
      reviews.forEach((review, i) => {
        const li = this.node('li', 'ns-reviews__item'); li.dataset.reviewId = review.id;
        const button = this.node('button', 'ns-reviews__card'); button.type = 'button'; button.dataset.reviewIndex = String(i);
        button.setAttribute('aria-label', `Bewertung von ${review.author} vollständig lesen`);
        const stars = this.node('span', 'ns-reviews__stars'); this.stars(stars, review.rating); button.append(stars);
        button.append(this.node('span', 'ns-reviews__title', review.title || '\u00a0'));
        button.append(this.node('span', 'ns-reviews__body', review.body));
        const byline = this.node('span', 'ns-reviews__byline');
        byline.append(this.node('span', 'ns-reviews__author', review.author));
        if (review.date) byline.append(this.node('span', 'ns-reviews__date', `, ${review.date}`));
        button.append(byline); li.append(button); fragment.append(li);
      });
      this.track.replaceChildren(fragment); this.hidden = false; this.updateButtons();
      if (this.photos) {
        const photos = document.createDocumentFragment();
        reviews.forEach((review, i) => {
          if (!review.photo) return;
          const li = this.node('li', 'ns-review-photos__item');
          const shopStrip = this.photos.closest('[data-home-customer-photos]');
          const match = shopStrip && this.products.find(p => p.title === review.product && p.url.startsWith('/products/'));
          if (shopStrip && !match) return;
          const button = this.node(match ? 'a' : 'button', 'ns-review-photos__card');
          if (match) button.href = match.url;
          else {button.type = 'button'; button.dataset.photoReview = String(i);}
          button.setAttribute('aria-label', match ? `${review.product} ansehen – Kundenfoto von ${review.author}` : `Foto und Bewertung von ${review.author} ansehen`);
          const img = this.node('img'); img.src=review.photo; img.alt=`Kundenfoto: ${review.product}`; img.loading='lazy'; img.width=360; img.height=450;
          img.addEventListener('error', () => {li.remove(); this.photos.hidden=!this.photoTrack.children.length; this.updatePhotoButtons();},{once:true});
          const caption=this.node('span','ns-review-photos__caption');
          caption.append(this.node('span','ns-review-photos__product',review.product || 'Kundenfoto'),this.node('span','ns-review-photos__author',review.author));
          const hint=this.node('span','ns-review-photos__hint',match ? 'Zum Produkt' : 'Foto ansehen');
          button.append(img,caption,hint);li.append(button);photos.append(li);
        });
        this.photoTrack.replaceChildren(photos); this.photos.hidden=!this.photoTrack.children.length;
        if (!this.photos.hidden) this.source.closest('[id$="__'+this.dataset.sourceSection+'"]').classList.add('ns-reviews-photo-source');
        this.updatePhotoButtons();
      }
    }
    updatePhotoButtons() {
      if (!this.photos) return;
      const progress=this.photos.querySelector('.ns-review-photos__progress span');
      if(progress) { const ratio=this.photoTrack.clientWidth/Math.max(1,this.photoTrack.scrollWidth); progress.style.width=`${Math.min(1,ratio)*100}%`; progress.style.transform=`translateX(${this.photoTrack.scrollLeft/Math.max(1,this.photoTrack.clientWidth)*100}%)`; }
      this.photos.querySelector('[data-photo-step="-1"]').disabled=this.photoTrack.scrollLeft<2;
      this.photos.querySelector('[data-photo-step="1"]').disabled=this.photoTrack.scrollLeft+this.photoTrack.clientWidth>=this.photoTrack.scrollWidth-2;
    }
    move(direction) {
      const card = this.track.firstElementChild; if (!card) return;
      this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + 15), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    updateButtons() {
      this.prev.disabled = this.track.scrollLeft < 2;
      this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
    }
    openReview(review) {
      if (!review) return;
      this.stars(this.querySelector('[data-dialog-stars]'), review.rating);
      this.querySelector('[data-dialog-title]').textContent = review.title || `Bewertung von ${review.author}`;
      this.querySelector('[data-dialog-body]').textContent = review.body;
      this.querySelector('[data-dialog-byline]').textContent = [review.author, review.date].filter(Boolean).join(', ');
      const photo = this.querySelector('[data-dialog-photo]');
      if (photo) { photo.hidden=!review.photo; if(review.photo) {photo.src=review.photo;photo.alt=`Kundenfoto: ${review.product}`;}else photo.removeAttribute('src'); }
      this.dialog.classList.toggle('ns-reviews__dialog--photo',Boolean(review.photo));
      const productLink=this.querySelector('[data-dialog-product]');
      const matches=this.products.filter(product=>product.title===review.product && /^\/products\//.test(product.url));
      productLink.hidden=matches.length!==1;
      if(matches.length===1){productLink.href=matches[0].url;productLink.textContent=`${review.product} ansehen`;}else productLink.removeAttribute('href');
      this.dialog.showModal();
    }
  }
  customElements.define('ns-review-carousel', ReviewCarousel);
})();
